import { KhoDeNghiXuatKhoPageService } from '../kho-de-nghi-xuat-kho-page-service/kho-de-nghi-xuat-kho-page.service';
import { KhoDeNghiXuatKhoPageDataSource } from './../kho-de-nghi-xuat-kho-page-datasource/kho-de-nghi-xuat-kho-page.datasource';

import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { merge, BehaviorSubject, fromEvent } from 'rxjs';
//Datasource
//Service

import { TokenStorage } from '../../../../../../core/auth/_services';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { TimKiemNangCaoDataSource } from '../../../../tim-kiem-nang-cao/datasource/tim-kiem-nang-cao.datasource';

import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../core/_base/crud';
import { ChiTietSoLuongTonModel } from '../kho-de-nghi-xuat-kho-page-model/kho-de-nghi-xuat-kho-page.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import moment from 'moment';
//Model


@Component({
	selector: 'm-chi-tiet-so-luong-ton-page',
	templateUrl: './chi-tiet-so-luong-ton-page.component.html',
	styleUrls: ['./chi-tiet-so-luong-ton-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})
export class ChiTietSoLuongTonPageComponent implements OnInit {
	// Config Form
	CONFIG: CommonConFig;

	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedTTHV: number[] = [];
	viewLoading = false;
	//#region Table fields
	dataSource:KhoDeNghiXuatKhoPageDataSource;
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MAKHO',
            displayName: 'Mã kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 2,
            name: 'TENKHO',
            displayName: 'Tên kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 2,
            name: 'SOLO',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'SLDUOCXUAT',
            displayName: 'SL được xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SLKHONGDUOCXUAT',
            displayName: 'SL không được xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'LYDOKHONGDUOCXUAT',
            displayName: 'Lý do không được xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'PO',
            displayName: 'PO',
            alwaysChecked: false,
			isShow: true
		}
	];
	//#endregion Table fields

	//#region Khai báo biến
	@ViewChildren('focus') focus ;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	@ViewChild('searchFullText', {static: true}) searchFullText: ElementRef;

	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChiTietSoLuongTonModel>(true, []);
	ChiTietSoLuongTonResult:ChiTietSoLuongTonModel[] = [];
	tmpChiTietSoLuongTonResult:ChiTietSoLuongTonModel[] = [];
	tmpChiTietSoLuongTonResultFull:ChiTietSoLuongTonModel[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;

	//#endregion Khai báo biến

	//#region Filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll=new BehaviorSubject<boolean>(false);
	//#endregion Filter on grid

	IdHH : number;
	Ma_Ten_HH: string;
	IdKho : number;

	PhanQuyen : boolean = false;
	warehouses = new BehaviorSubject<any[]>([]);

	// CONST CẢNH BÁO
	title = "Thông tin tồn kho";
	subTitleLeft = "Hàng hóa ";
	subTitleRight = " không có dữ liệu tồn kho.";
	description = "Vui lòng nhập kho để thêm tồn kho cho hàng hóa.";
	receiveData = new BehaviorSubject<boolean>(false);

	//#region Constructor
	constructor(
		private KhoDeNghiXuatKhoService : KhoDeNghiXuatKhoPageService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChung : DungChungService,
		public dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		public dialogRef: MatDialogRef<ChiTietSoLuongTonPageComponent>,
		private layoutUtilsService: LayoutUtilsService) {
			this.dialogRef.disableClose = true;
		}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		this.IdHH = this.data.IdHH;
		this.Ma_Ten_HH = this.data.Ma_Ten_HH;
		this.IdKho = this.data.IdKho;
		this.PhanQuyen = this.data.PhanQuyen ? this.data.PhanQuyen : false;
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.showColumnsInTable();
		this.applySelectedColumns();

		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});
		const queryParams = new QueryParamsModel(this.filterConfiguration(),'asc','',0,10,{},true);
		this.KhoDeNghiXuatKhoService.getDataSLTon(queryParams).subscribe(res => {
			if(res && res.status == 1){
				var result = res.data ? res.data : [];
				while (result.length > 0) {
					const currentItem = result[0];
					var dataGroupByWarehouseAndInvId = result.filter(_x => _x.Id == currentItem.Id && _x.SoLo == currentItem.SoLo);
					this.tmpChiTietSoLuongTonResult = [...this.tmpChiTietSoLuongTonResult, ...dataGroupByWarehouseAndInvId];
					result = result.filter(_x => _x.Id != currentItem.Id || _x.SoLo != currentItem.SoLo);
				}
				this.tmpChiTietSoLuongTonResultFull = [...this.tmpChiTietSoLuongTonResult];
				this.receiveData.next(true);
				this.getWarehouses();
				this.changeDetect.detectChanges();
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	//#region Load danh sách
	loadChiTietSoLuongTonPagePre(highlight: boolean = false) {
		if(highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = (this.paginator.pageIndex > 0)? this.paginator.pageIndex - 1 : 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadChiTietSoLuongTon(queryParams);
	}

	loadChiTietSoLuongTon(highlight: boolean = false) {
		if(highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			0,
			5,
			this.filterGroupData
		);
		this.dataSource.loadChiTietSoLuongTon(queryParams);
	}

	loadChiTietSoLuongTonInit(highlight: boolean = false) {
		if(highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadChiTietSoLuongTon(queryParams);
	}
	//#endregion Load danh sách

	//#region FILTRATION
	filterConfiguration(): any {
		const filter: any = {};
		//filter.FullSearch = this.searchFullText.nativeElement.value;
		filter.IdHH = this.IdHH ? this.IdHH : 0;
		filter.IdKho = this.IdKho ? this.IdKho : 0;
		filter.PhanQuyen = this.PhanQuyen ? '1' : '0';
		return filter;
	}
	//#endregion FILTRATION

	//#region Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}

	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}

    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}

	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}

	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}

	dropListDropped(event: CdkDropList, column: string) {

		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	//#endregion Apply selected Column

	checkDashboardRoute(){
		if(this.router.url === '/')
			return true;
		return false;
	}
	//#endregion Kiểm tra người dùng, đường dẫn

	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col , isSelect = true) {
		let countChecked = 0;

		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		}else{
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if(_arrflt.length == 0 && this.filterGroupArray[key].length == 1){
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll.next(true);
		}
		else {
			this.isClearAll.next(false);
		}
	}
	filterHead(col, isSelect = true) {
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {

					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);

					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				//this.filterConfiguration();
			}
			//this.loadChiTietSoLuongTonInit();
			this.isClearAll.next(this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL'));
		}else{
			if (this.filterGroupDataCheckedFake ) {
				if(!this.filterGroupDataCheckedFake[col]){
					this.remove('', col, false);
				}else{
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if(this.filterGroupData[col])
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				//this.filterConfiguration();
			}
			//this.loadChiTietSoLuongTonInit();
			this.isClearAll.next(this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false));
			this.filterGroupDataCheckedFake[col] = '';
		}
		this.filterClient();
	}
	remove(item, col, isSelect = true) {
		if(isSelect){
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				//this.loadChiTietSoLuongTonInit();
			}
		}else{
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				//this.loadChiTietSoLuongTonInit();
			}
		}
		this.filterClient();
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll.next(false);
		this.filterClient();
	}

	checkFilterHasValue(data, col, isSelect = true) {

		let _count = 0;
		if(isSelect){
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		}else{
			if(data && data[col] && data[col].length > 0){
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}
	filterClient() {
		const list_search 			= this.filterGroupArray;
		const WarehouseCodeFilter 	= list_search["MaKho"];
		const WarehouseNameFilter 	= list_search["TenKho"];
		const LOTFilter 	= list_search["SoLo"];

		this.tmpChiTietSoLuongTonResult = [...this.tmpChiTietSoLuongTonResultFull];
		if (WarehouseCodeFilter && WarehouseCodeFilter.length > 0) {
			var kw = this.Normalize(this.CStr(WarehouseCodeFilter[0]));
			this.tmpChiTietSoLuongTonResult = this.tmpChiTietSoLuongTonResult.filter((x) => 
				x.MaKho 
				&& this.Normalize(x.MaKho).indexOf(kw) > -1
			);
		}
		if (WarehouseNameFilter && WarehouseNameFilter.length > 0) {
			var kw = this.Normalize(this.CStr(WarehouseNameFilter[0]));
			this.tmpChiTietSoLuongTonResult = this.tmpChiTietSoLuongTonResult.filter((x) => 
				x.TenKho 
				&& this.Normalize(x.TenKho).indexOf(kw) > -1
			);
		}
		if (LOTFilter && LOTFilter.length > 0) {
			var kw = this.Normalize(this.CStr(LOTFilter[0]));
			this.tmpChiTietSoLuongTonResult = this.tmpChiTietSoLuongTonResult.filter((x) => 
				x.SoLo 
				&& this.Normalize(x.SoLo).indexOf(kw) > -1
			);
		}
		this.tmpChiTietSoLuongTonResult = [...this.tmpChiTietSoLuongTonResult];
		this.changeDetect.detectChanges();
	}
	//#endregion Filter function

	back(){
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd : this.saveAddedTTHV
		});
	}

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '0.00';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	// .. Điều chỉnh hàm format
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}

	getWarehouses(){
		let details = this.tmpChiTietSoLuongTonResult == null ? [] : this.tmpChiTietSoLuongTonResult;
		let warehouses = [];
		details.forEach(_x => {
			if(warehouses.find(_w => _w["id_kho"] == _x.Id) == null){
				warehouses.push({id_kho: _x.Id, ma_kho: _x.MaKho, ten_kho: _x.TenKho});
			}
		});
		this.warehouses.next(warehouses);
	}

	getDetailsToIdWarehouse(id_kho: number){
		return this.tmpChiTietSoLuongTonResult.filter(_x => _x.Id == id_kho).sort((a, b) => {
			let a_po = a.POStr;
			let b_po = b.POStr;
			return a_po < b_po ? -1 : a_po > b_po ? 1 : 0;
		});
	}

	sumDetailsAcceptToIdWarehouse(){
		let list = this.tmpChiTietSoLuongTonResult;
		const sum = list.reduce((accumulator, object) => {
			return accumulator + object.SLDuocXuat;
		}, 0); 
		return sum.toString();
	}
	// .. Hàm format chuỗi
	CStr(str){return str.toString();}
	LRTrim(str){return str.toString().trim();}
	LCase(str){return str.toLowerCase();}
	Normalize(str){return this.LCase(this.LRTrim(str)).normalize("NFC");}
	CMomentDate(value){return moment(value).format("YYYY-MM-DD[T]HH:mm:ss.SSS");}

	numberColSpan(index){
		var item = this.tmpChiTietSoLuongTonResult[index];
		var firstIndex = this.tmpChiTietSoLuongTonResult.findIndex(x => x.MaKho == item.MaKho);
		if (firstIndex == index)
			return this.tmpChiTietSoLuongTonResult.filter(x => x.MaKho == item.MaKho).length;
		return 0;
	}
	groupByBatchNumber(index) {
		var list = this.tmpChiTietSoLuongTonResult;
		var item = list[index];
		var firstIndex = list.findIndex(x => x.MaKho == item.MaKho && x.SoLo == item.SoLo && x.NgayNhapKho == item.NgayNhapKho);
		if (firstIndex == index)
			return list.filter(x => x.MaKho == item.MaKho && x.SoLo == item.SoLo && x.NgayNhapKho == item.NgayNhapKho).length;
		return 0;
	}
	getTextColor(backgroundColor: string): string {
		// Chuyển màu nền từ mã hex thành RGB
		const bgR = parseInt(backgroundColor.substring(1, 3), 16);
		const bgG = parseInt(backgroundColor.substring(3, 5), 16);
		const bgB = parseInt(backgroundColor.substring(5, 7), 16);

		// Tính độ tương phản
		const contrast = (bgR * 0.299 + bgG * 0.587 + bgB * 0.114);

		// Trả về màu chữ dựa trên độ tương phản
		if (contrast > 128) {
			return '#000000'; // Màu chữ black
		} else {
			return '#ffffff'; // Màu chữ white
		}
	}
	getGroupNumberByWarehouse(warehouseID: number) {
		var listWarehouse = this.tmpChiTietSoLuongTonResult.map(x => x.Id);
		var uniqueList = listWarehouse.filter((item, index) => listWarehouse.indexOf(item) === index);
		return uniqueList.indexOf(warehouseID) + 1;
	}
}
